

var pass = {
	regex:/\[\[([\s\S]+?)\]\]/g,
	mapper: function( match, inner ) {
		return "function() {\n try { with( data ) {\n return " + inner + " } } catch (error) { this.log( error ) } }.call( this )";
	}
};

var cache = {};


/**
 * Compiles a template string into a template function.
 */
export function compile( templateString:string, args:string[] = [ 'data' ] ):Function {

	let key = templateString + args.join( ' ' );

	// handle caching
	if( cache[ key ] ) return cache[ key ]

	// check if template is one single [[ .. ]] expression
	let matches = templateString.match( /\[\[([\s\S]+?)\]\]/ );
	if( matches && matches[0] == templateString ) {
		var source = parseValue( templateString );
	} else {
		var source = parseString( templateString );
	}

	var render = new Function( ...args, source );

	// store for caching
	cache[ key ] = render;

	return render;
}


/**
* Turns the given template into a function body code.
*/
function parseString( template:string ):string {

	template = template.replace( pass.regex, ( match, inner:string ) => {
		return "` + this.empty( " + pass.mapper( match, inner ) + " ) + `";
	});

	return "return `" + template + "`;";
}

/**
* Turns the given template into a function body code.
*/
function parseValue( template:string ):string {
	// simply return the inner template content
	return template.replace( pass.regex, ( match, inner:string ) => {
		return "return " + pass.mapper( match, inner ) + ";";
	});
}

/**
 * Tests if the value of the template is empty or not
 */
export function empty( data:any ):string {
	return data || data === 0 ? data : '';
}

/**
 * Logs errors to the console
 */
export function log( ...params ) {
	if( console ) {
		( console.trace ) ? console.trace( ...params ) : console.log( ...params );
	}
}

/**
 * Stops the debugger
 */
export function debug() {
	debugger;
}

/**
 * Tests if the given string has an expression
 * @param string
 */
export function hasExpression( string:string ):boolean {
	pass.regex.lastIndex = 0; // reset global regex
	return pass.regex.test( string );
}

/**
 * Returns only the content of the expressions [[...]] within the given string
 */
export function getContent( string:string ) {
	let content = '';
	string.replace( pass.regex, ( match, inner ) => {
		content += inner;
		return '';
	});
	return content;
}

/**
 * Replaces the expression of the given templatee with the content of the closure
 */
export function replace( template:string, replacer:( match:string, inner ) => string ) {
	return template.replace( pass.regex, replacer );
}
